'use client'
import { VisaBookingList } from '@/src/types/visa/visaBookingList'
import { formatStatusText } from '@/src/utils/visa'
import { Button, Container, Spacer, Typography } from '@ct-design/lib'

const VisaCard = ({
    bookings,
    className
}: {
    className?: string
    bookings: VisaBookingList
}) => {
    const bookingList = bookings.searchCriteria

    return (
        <Container
            className={`flex flex-column ba-solid br-8 bc-line-500 mr-4 ${className}`}
            width='330px'
            style={{
                minWidth: '330px'
            }}
        >
            <Container className='flex flex-1 flex-between mb-3'>
                <Typography variant='HM3'>
                    {bookings.destinationCountry +
                        ' ' +
                        bookingList.visaCategory +
                        ' Visa'}
                </Typography>
                <Spacer className='mr-1' />
                <Typography
                    variant='B2'
                    color='alert'
                    className='mr-4 ta-r w-20'
                >
                    {formatStatusText(bookings.status)}
                </Typography>
            </Container>

            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Destination Country</Typography>
                <Typography variant='B2'>
                    {bookings.destinationCountry}
                </Typography>
            </Container>
            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Visa Type</Typography>
                <Typography variant='B2'>{bookingList.visaCategory}</Typography>
            </Container>
            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Entry Type</Typography>
                <Typography variant='B2'>{bookingList.entryType}</Typography>
            </Container>
            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Processing Speed</Typography>
                <Typography variant='B2'>
                    {bookingList.processingSpeed}
                </Typography>
            </Container>
            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Date of Visa</Typography>
                <Typography variant='B2'>{bookingList.dateOfVisa}</Typography>
            </Container>
            <Container className='flex flex-1 flex-between mt-3'>
                <Typography variant='P2'>Validity</Typography>
                <Typography variant='B2'>{bookings.days}</Typography>
            </Container>
            <Container className='flex flex-1 flex-center mt-6'>
                <Button
                    onClick={() =>
                        (window.location.href = `/visa/dashboard/${bookings.itineraryId}`)
                    }
                    color='secondary'
                >
                    View Application
                </Button>
            </Container>
        </Container>
    )
}

export default VisaCard
